import IAddinCommand from '../store/schema/interfaces/IAddinCommand';
import getExtensibilityState from '../store/getExtensibilityState';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'setBlockedAddinCommand',
    (addinCommand: IAddinCommand, hostItemIndex: string) => {
        const blockedAddinCommands = getExtensibilityState().blockedAddinCommands;
        if (!blockedAddinCommands.has(hostItemIndex)) {
            blockedAddinCommands.set(hostItemIndex, new Set<IAddinCommand>());
        }
        blockedAddinCommands.get(hostItemIndex).add(addinCommand);
    }
);
